module.exports = __webpack_public_path__ + "img/DeliveredActive.d2588e16.svg";